var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row align-items-center" }, [
    _c(
      "div",
      { staticClass: "col-md-5" },
      [
        _c("list-user", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            }
          ],
          ref: "passenger",
          staticClass: "w-100",
          attrs: {
            autocomplete: "",
            label: "Pasajero",
            name: "passenger",
            "data-cy": "passenger",
            "data-vv-as": "pasajero",
            danger: _vm.errors.has("custom-document-part-4.passenger"),
            "danger-text": _vm.errors.first("custom-document-part-4.passenger")
          },
          model: {
            value: _vm.passengerForm.passenger,
            callback: function($$v) {
              _vm.$set(_vm.passengerForm, "passenger", $$v)
            },
            expression: "passengerForm.passenger"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-4 mt-4" },
      [
        _c(
          "b-button",
          {
            directives: [
              {
                name: "ripple",
                rawName: "v-ripple.400",
                value: "rgba(255, 255, 255, 0.15)",
                expression: "'rgba(255, 255, 255, 0.15)'",
                modifiers: { "400": true }
              }
            ],
            attrs: { "data-cy": "add-passenger-button", variant: "primary" },
            on: {
              click: function($event) {
                return _vm.addPassenger()
              }
            }
          },
          [_vm._v(" Agregar Pasajero ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }